import React, { Component } from 'react';
import { MuiGrid, MuiMenuItem, MuiDivider, MuiTypography } from '../../ui/MaterialUIComponents';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import SignOutContainer from '../../functional/authentication/signout/SignOutContainer';
import theme from '../../../assests/theme'
import * as dropDownMenuList from './DropDownProfileMenuList'
import routes from '../../navigation/Routes'
class ProfileMenu extends Component {
  render() {
    return (
      <MuiGrid style={{ padding: 8 }} >
        <MuiGrid item container direction='row' spacing={8} justify='center' alignItems='center'>
          <MuiGrid item >
            <MuiTypography color='primary' variant={theme.typography.title} style={{ color: theme.palette.primary.darker }}><b>{this.props.userInformation.firstName != undefined ? this.props.userInformation.firstName.toLocaleUpperCase() : null} {this.props.userInformation.lastName != undefined ? this.props.userInformation.lastName.toLocaleUpperCase() : null} </b></MuiTypography>
          </MuiGrid>
        </MuiGrid>
        <MuiDivider />
        {dropDownMenuList.menuList.map((menuItem) => <Link to={menuItem.route} style={{ cursor: 'pointer', textDecoration: 'none' }}>
          <MuiMenuItem>
            <MuiTypography variant={theme.typographyStyles.BODY2} style={{ color: theme.palette.primary.darker }}>{menuItem.name}</MuiTypography>
          </MuiMenuItem>
        </Link>)}
        {this.props.systemConfig.showLicense ? <Link to={routes.subscription} style={{ cursor: 'pointer', textDecoration: 'none' }}>
          <MuiMenuItem>
            <MuiTypography variant={theme.typographyStyles.BODY2} style={{ color: theme.palette.primary.darker }}>License</MuiTypography>
          </MuiMenuItem>
        </Link> : null}
        {/* {this.props.systemConfig.showLicense ? <Link to={routes.orderHistory} style={{ cursor: 'pointer', textDecoration: 'none' }}>
          <MuiMenuItem>
            <MuiTypography variant={theme.typographyStyles.BODY2} style={{ color: theme.palette.primary.darker }}>Order History</MuiTypography>
          </MuiMenuItem>
        </Link> : null} */}
        <MuiMenuItem>
          <SignOutContainer />
        </MuiMenuItem>
      </MuiGrid>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    user: state.cognito.user,
    userInformation: state.userProfile.userInformation,
    systemConfig: state.systemConfig.systemConfig
  }
}
export default connect(mapStateToProps, null)(ProfileMenu); 
